import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface Payload {
  isHa: boolean;
  isRented: boolean;
  isLocalStudent: boolean;
  reason: string;
  how: string;
  why: string;
}

export default (makeCall: MakeCall) => (listingId: number, data: Payload) =>
  makeCall<undefined>('PUT', `${APIV2_URL}/listing/${listingId}/hide`, {
    data,
  });

export type HideListingCall = (
  listingId: number,
  data: Payload,
) => Promise<void>;
